import api from '../api/tags-api';

export default {
  getTagsList(params, headers) {
    return new Promise((resolve, reject) => {
      api.getTagsList(params, headers).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || []);
        } else {
          reject(data);
        }
      });
    });
  },
  addTag(data) {
    return new Promise((resolve, reject) => {
      api.addTag(data).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || []);
        } else {
          reject(data);
        }
      });
    });
  },
  delTag(data) {
    return new Promise((resolve, reject) => {
      api.delTag(data).then(({data}) => {
        if (data.code === 200) {
          resolve(data.result || []);
        } else {
          reject(data);
        }
      });
    });
  }
}